export default __webpack_public_path__ + "197adda75dbdea9f9ddbcdb9ddc956b5.svg";